import React from 'react';
import { modules } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-206" data-mp="100c9f2m1l0zr">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-207" data-mp="zy97plbj1jf7">
        <header className="mx-auto max-w-4xl text-center" data-id="element-208" data-mp="l4mrpgnw3a0u">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 [text-wrap:balance] md:text-5xl" data-id="element-209" data-mp="q264ec4xveqo">
            Sistema completo: <span className="text-blue-600" data-id="element-210" data-mp="1dsiosmhdf3y5">50 Mapas Visuales</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base font-semibold text-slate-600 [text-wrap:balance] md:mt-5 md:text-lg" data-id="element-211" data-mp="1iq21hhyf78nz">
            15 mapas TENS · 18 mapas NMES · 9 mapas FES · 8 mapas de interferencial y técnicas.
          </p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-212" data-mp="1wquyc9c72fu9">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-213" data-mp="21hbdpyzksbj9">
              <div className="flex items-baseline gap-3" data-id="element-214" data-mp="2vdpx7q4ieakd">
                <span className="text-5xl font-extrabold leading-none tracking-tight text-teal-900" data-id="element-215" data-mp="2qhsdd9u1em2u">
                  {module.count}
                </span>
                <span className="text-sm font-extrabold uppercase tracking-[0.12em] text-teal-900/80" data-id="element-216" data-mp="30ex4lo2qp7qi">
                  mapas
                </span>
              </div>
              <h3 className="mt-4 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-217" data-mp="3e4h1id9n3arw">
                {module.title}
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-218" data-mp="3o47u29en3fpc">{module.summary}</p>
              <p className="mt-auto pt-4 font-semibold text-blue-700" data-id="element-219" data-mp="3o2exxo1nkdvl">{module.closing}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}